<template>
  <div>
    <common-search-form-wrapper :hiddenExpand="true" :reset="handleResetSearch">
      <el-form
        size="mini"
        ref="mainForm"
        :model="searchInfo"
        label-width="64px"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="点名时间:">
              <!-- <el-date-picker
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            v-model="searchInfo.rollcallTime"
            @change="handleSearch"
          >
          </el-date-picker> -->
              <common-date-range-selector
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                v-model="searchInfo.rollcallTime"
                @change="handleSearch"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="班级名称:">
              <el-select
                v-model.number="searchInfo.class_id"
                filterable
                clearable
                placeholder="请选择班级"
                @change="handleSearch"
                :filter-method="handleSearchClass"
                @focus="handleSearchClass('')"
              >
                <el-option
                  v-for="item in searchClassList"
                  :key="item.class_id"
                  :label="item.name"
                  :value="Number(item.class_id)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="排课课程:">
              <el-select
                v-model.number="searchInfo.course_id"
                filterable
                clearable
                placeholder="请选择排课课程"
                :filter-method="handleSearchCourse"
                @focus="handleSearchCourse('')"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in searchCourseList"
                  :key="item.course_id"
                  :label="item.title"
                  :value="Number(item.course_id)"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="上课时间:">
              <!-- <el-date-picker
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            v-model="searchInfo.lessonTime"
            @change="handleSearch"
          >
          </el-date-picker> -->
              <common-date-range-selector
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                v-model="searchInfo.lessonTime"
                @change="handleSearch"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      size="mini"
      v-horizontal-scroll
      ref="mainTable"
      tooltip-effect="dark"
      style="width: 100%"
      :data="tableData"
      stripe
    >
      <el-table-column label="点名时间" prop="create_time">
        <template slot-scope="scope">
          <div>
            {{ scope.row.create_time }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="班级名称" prop="class.name"> </el-table-column>
      <el-table-column label="排课课程" prop="course.title"> </el-table-column>
      <el-table-column label="上课时间" width="220">
        <template slot-scope="scope">
          <div>
            {{ scope.row.lesson_date }}
            {{ scope.row.class_lesson.start_time.slice(0, 5) }} ~
            {{ scope.row.class_lesson.end_time.slice(0, 5) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="consume_number">
        <template slot="header">
          <div class="selfheader">
            <div>耗课数</div>
            <el-popover
              placement="top"
              width="190"
              popper-class="followuppopover"
              trigger="hover"
            >
              <p>点名签到后，所扣除的课程课时数</p>
              <div class="question" slot="reference">
                <div>?</div>
              </div>
            </el-popover>
          </div>
        </template>
        <template slot-scope="scope">
          <div>{{ scope.row.consume_number }}</div>
        </template>
      </el-table-column>
      <el-table-column label="签到数/总人数">
        <template slot-scope="scope">
          <div
            :class="[
              scope.row.attend_student_count == 0
                ? 'delBtn'
                : scope.row.attend_student_count != scope.row.student_count
                ? 'red'
                : 'green',
            ]"
          >
            {{ scope.row.attend_student_count }}/{{ scope.row.student_count }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <rollcall-details-dialog
            :rollcall-id="scope.row.roll_call_id"
            :class-data="scope.row.class"
          >
            <div class="mwow-button primary" style="margin-right: 10px">
              查看
            </div>
          </rollcall-details-dialog>
          <div class="mwow-button success" @click="toRollcallDetail(scope.row)">
            编辑
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      :style="{ float: 'right', padding: '17px' }"
    >
    </el-pagination>
  </div>
</template>
<script>
import { rollCallListData, rollCallList } from "@/api/teacherManage";
import { getSelectClassList, getSelectCourseList } from "@/api/globalSearch";
import rollcallDetailsDialog from "./rollcallDetailDialog.vue";
import { dateFormat } from "@/utils/timeFormat";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
export default {
  props: ["visible"],
  components: {
    rollcallDetailsDialog,
    commonDateRangeSelector,
    CommonSearchFormWrapper,
  },
  data() {
    return {
      searchInfo: {
        rollcallTime: [],
        class_id: "",
        course_id: "",
        lessonTime: [],
      },
      searchCourseList: [],
      searchClassList: [],
      tableData: [],
      page: 1,
      pageSize: 20,
      pageSizeArray: [20, 50, 100],
      total: 0,
    };
  },
  mounted() {
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.getClassLog({
          page: 1,
          page_size: this.pageSize,
        });
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.getClassLog({
        page: 1,
        page_size: this.pageSize,
      });
    }
  },
  methods: {
    handleResetSearch() {
      this.searchInfo = {
        rollcallTime: [],
        class_id: "",
        course_id: "",
        lessonTime: [],
      };
      this.handleSearch();
    },
    handleSearchClass(v) {
      getSelectClassList({
        page: 1,
        page_size: 50,
        name: v,
      }).then((res) => {
        this.searchClassList = res.data.list;
      });
    },
    handleSearchCourse(v) {
      getSelectCourseList({
        page: 1,
        page_size: 100,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.searchCourseList = res.data.list;
        }
      });
    },
    handleSearch() {
      this.getClassLog({
        page: 1,
        page_size: this.pageSize,
      });
    },
    getClassLog(data) {
      data.teacher_id = Number(this.$route.query.id);
      data.status = 1;
      if (this.searchInfo.class_id) {
        data.class_id = this.searchInfo.class_id;
      }
      if (this.searchInfo.course_id) {
        data.course_id = this.searchInfo.course_id;
      }
      if (this.searchInfo.staff_id) {
        data.staff_id = this.searchInfo.staff_id;
      }
      if (
        this.searchInfo.rollcallTime &&
        this.searchInfo.rollcallTime.length === 2
      ) {
        data.roll_call_start_date = this.searchInfo.rollcallTime[0];
        data.roll_call_end_date = this.searchInfo.rollcallTime[1];
      }
      if (
        this.searchInfo.lessonTime &&
        this.searchInfo.lessonTime.length === 2
      ) {
        data.lesson_start_date = this.searchInfo.lessonTime[0];
        data.lesson_end_date = this.searchInfo.lessonTime[1];
      }
      rollCallList(data).then((res) => {
        if (res.error_code == 0) {
          if (res.data.list != null) {
            res.data.list.map((a) => {
              a.create_time = dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(Number(a.create_time + "000"))
              );
            });
          }
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.page = res.data.page;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    handlePagerChange(e) {
      this.page = e;
      this.getClassLog({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getClassLog({
        page: 1,
        page_size: e,
      });
    },
    toRollcallDetail(row) {
      this.$router.push({
        name: "rollCallDetails",
        query: { id: row.roll_call_id },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.selfheader {
  display: flex;
  align-items: center;
}
.question {
  width: 15px;
  height: 15px;
  opacity: 1;
  background: #bebfc0;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 16px;
  font-size: 10px;
  margin-left: 5px;
}
.red {
  color: #f56c6c;
}
.green {
  color: #07d1aa;
}
.delBtn {
  color: #5c5d5e;
}
</style>
